import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const receiveOrderItem = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("receive-order-items"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("receive-order-items/" + id));
    return data;
  },
  store: async (items) => {
    const { data } = await axios.post(h.baseUrl("receive-order-items"), {
      items,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (id, qty, createNew, receiveAllItem = false) => {
    const { data } = await axios.put(h.baseUrl("receive-order-items/" + id), {
      qty,
      createNew,
      receiveAllItem,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("receive-order-items/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default receiveOrderItem;
